import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-applicationstatus',
  templateUrl: './applicationstatus.component.html',
  styleUrls: ['./applicationstatus.component.css']
})
export class ApplicationstatusComponent implements OnInit {

  title = "Application - Status"; 
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/applicant/applicationstatus/applicationstatus.component.ts